import { render, staticRenderFns } from "./FilesViewFileDropEmptyContent.vue?vue&type=template&id=994fb45e&scoped=true"
import script from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesViewFileDropEmptyContent.vue?vue&type=style&index=0&id=994fb45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994fb45e",
  null
  
)

export default component.exports